import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCountryShortName } from '@shared/selectors';
import getHighlightedProducts from '@core/reducers/menu/selectors/getHighlightedProducts';
import { getDiscountsProducts } from '@core/reducers/menu/selectors/getDiscountsProducts';
import getPreferredDishesProducts from '@shopDetails/selectors/getPreferredDishesProducts';
import trackSwimlaneShown from '@shopDetails/tracking/actions/trackSwimlaneShown';
import trackSwimlaneSwiped from '@shopDetails/tracking/actions/trackSwimlaneSwiped';
import Swimlanes from './Swimlanes';

const mapDispatchToProps = {
  trackSwimlane: trackSwimlaneShown,
  trackSwimlaneSwiped,
};

const mapStateToProps = createStructuredSelector({
  highlightedProducts: getHighlightedProducts,
  discountsProducts: getDiscountsProducts,
  countryCode: getCountryShortName,
  preferredDishesProducts: getPreferredDishesProducts,
});

export default connect(mapStateToProps, mapDispatchToProps)(Swimlanes);
